module.exports = __webpack_public_path__ + "assets/terrain.144b89da.svg";